import View from '@/components/common/view'
import TraineeEmployerIndex from '../components/yanbao/Index';

export default [
	{
		path:'',
		component:TraineeEmployerIndex,
	},
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/yanbao.js